import type { ReactNode } from "react";
import { AlertCircle, CheckCircle2, Info, TriangleAlert } from "lucide-react";
import { cn } from "../../lib/cn.js";

type Tone = "info" | "success" | "warning" | "danger";

const TONE_CLASS: Record<Tone, string> = {
  info: "border-accent/30 bg-accent-subtle text-text-primary",
  success: "border-status-success/30 bg-status-success/10 text-text-primary",
  warning: "border-status-warning/30 bg-status-warning/10 text-text-primary",
  danger: "border-status-danger/30 bg-status-danger/10 text-text-primary"
};

const ICONS: Record<Tone, ReactNode> = {
  info: <Info className="h-4 w-4 text-accent" />,
  success: <CheckCircle2 className="h-4 w-4 text-status-success" />,
  warning: <TriangleAlert className="h-4 w-4 text-status-warning" />,
  danger: <AlertCircle className="h-4 w-4 text-status-danger" />
};

export function Alert({
  tone = "info",
  title,
  children,
  className
}: {
  tone?: Tone;
  title?: ReactNode;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex items-start gap-2 rounded border px-3 py-2 text-sm",
        TONE_CLASS[tone],
        className
      )}
    >
      <span className="mt-0.5">{ICONS[tone]}</span>
      <div className="space-y-0.5">
        {title && <div className="font-medium">{title}</div>}
        {children && <div className="text-text-secondary">{children}</div>}
      </div>
    </div>
  );
}
